import { useState, useEffect, useContext, useMemo, useRef } from "react";
import { FindifyDataContext } from "@/contexts/FindifyDataContext";
import { loadApiData } from "../helpers/RoutesHelper";
import { genericRoutes, GenericRoute } from "../../place/PlaceAppRoutes";

export const useAppRoutes = (overrides: GenericRoute[] = []) => {
    const findifyDataContext = useContext(FindifyDataContext);
    
    // Check if workspace is already fully loaded (has languages)
    const hasData = !!(findifyDataContext?.workspace?.languages && findifyDataContext?.workspace?.languages.length > 0);
    const [lodadedInitialData, setLoadedInitialData] = useState(hasData);
    const isFirstLoad = useRef(true);

    useEffect(() => {
        if (isFirstLoad.current && findifyDataContext) {
            if (hasData) {
                setLoadedInitialData(true);
            } else {
                loadApiData(setLoadedInitialData, findifyDataContext);
            }
            isFirstLoad.current = false;
        }
    }, [findifyDataContext, hasData]);

    const placeRoutes = useMemo(() => {
        return genericRoutes(overrides);
    }, [overrides]);

    return {
        lodadedInitialData,
        placeRoutes,
        findifyDataContext
    };
};
